/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { HorizontalPosition, PhxSliderTrackStyle } from './phx-slider.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'phx-slider-track',
  exportAs: 'phxSliderTrack',
  preserveWhitespaces: false,
  template: ` <div class="phx-slider-track" [ngStyle]="style"></div> `
})
export class PhxSliderTrackComponent implements OnChanges {
  static ngAcceptInputType_phxOffset: number;
  static ngAcceptInputType_phxLength: number;

  @Input() phxOffset: number = 0;
  @Input() phxLength: number = 0;

  style: PhxSliderTrackStyle = {};

  ngOnChanges(): void {
    const length = this.phxLength;

    const positonStyle: PhxSliderTrackStyle = {
          ...this.getHorizontalStylePosition(),
          width: `${length}%`,
        };

    this.style = positonStyle;
  }

  private getHorizontalStylePosition(): HorizontalPosition {
    const left = `${this.phxOffset}%`;
    const right = 'auto';
    return { left, right };
  }
}